import { sheetTypeEnum } from '@/utils/enum';
import type z from 'zod';
import type { projectRelationType } from '../../_models/project';

export const getRequestSheetTypeByRelationType = (
  relationType: z.infer<typeof projectRelationType> | undefined,
) => {
  switch (relationType) {
    case 'ks-link-base':
    case 'ss-link-base':
      return sheetTypeEnum.Values.RS;
    case 'ks-link-target':
      return sheetTypeEnum.Values.KS;
    case 'ss-link-target':
      return sheetTypeEnum.Values.SS;
    default:
      return undefined;
  }
};
